import { render } from "./ModificaRapportino.vue?vue&type=template&id=d99555fe&scoped=true"
import script from "./ModificaRapportino.vue?vue&type=script&lang=js"
export * from "./ModificaRapportino.vue?vue&type=script&lang=js"

import "./ModificaRapportino.vue?vue&type=style&index=0&id=d99555fe&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_plan_1778832654194047890/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d99555fe"]])

export default __exports__